<div class="onboard-container">
    <ng-content>

    </ng-content>
</div>
